export class CustomerRemovalControlStatusConstant {
    static AWAITING_RETURN_ID = "AWAITING_RETURN";
    static RETURNED_ID = "RETURNED";
  
    static OPTIONS = {
      [this.AWAITING_RETURN_ID]: {
        label: "En attente de restitution",
        color: "orange",
      },
      [this.RETURNED_ID]: {
        label: "Restitué",
        color: "green",
      },
    };
  }